module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.a08d56bfe7c1290692bc.worker.js");
}
